export default __webpack_public_path__ + "static/media/admin_product_customer_active.95c85585.svg";